/* Sea Moss gallery. Product forms and FAQ details retain native browser behavior. */
(function () {
  'use strict';
  function boot(scope) {
    scope.querySelectorAll('.fsm-gallery').forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      var slides = Array.from(gallery.querySelectorAll('.fsm-gallery-slide'));
      var thumbs = Array.from(gallery.querySelectorAll('.fsm-thumb'));
      var active = 0;
      var finishTransition = null;
      function select(index) {
        if (finishTransition) finishTransition();
        var previous = active;
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.hidden = i !== active; });
        thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-pressed', String(i === active)); });
        if (previous === active || !slides[active].animate ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var outgoing = slides[previous];
        var incoming = slides[active];
        var direction = index > previous ? 1 : -1;
        outgoing.hidden = false;
        outgoing.setAttribute('aria-hidden', 'true');
        var options = { duration: 280, easing: 'cubic-bezier(.25,.1,.25,1)', fill: 'both' };
        var exit = outgoing.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(' + (-direction * 100) + '%)' }
        ], options);
        var enter = incoming.animate([
          { transform: 'translateX(' + (direction * 100) + '%)' },
          { transform: 'translateX(0)' }
        ], options);
        function finish() {
          if (finishTransition !== finish) return;
          finishTransition = null;
          outgoing.hidden = true;
          outgoing.removeAttribute('aria-hidden');
          exit.cancel();
          enter.cancel();
        }
        finishTransition = finish;
        enter.onfinish = finish;
      }
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { select(i); });
        thumb.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          select(active + (event.key === 'ArrowRight' ? 1 : -1));
          thumbs[active].focus();
        });
      });
      var gesture = null;
      var stage = gallery.querySelector('.fsm-gallery-stage');
      function resetGesture() { gesture = null; }
      stage.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) { resetGesture(); return; }
        var touch = event.touches[0];
        gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY };
      }, { passive: true });
      stage.addEventListener('touchmove', function (event) {
        if (!gesture) return;
        if (event.touches.length !== 1) { resetGesture(); return; }
        var touch = event.touches[0];
        if (touch.identifier !== gesture.id) { resetGesture(); return; }
        var dx = Math.abs(touch.clientX - gesture.x);
        var dy = Math.abs(touch.clientY - gesture.y);
        // A page scroll must never become a gallery swipe later in the gesture.
        if (dy > 12 && dy >= dx) resetGesture();
      }, { passive: true });
      stage.addEventListener('touchcancel', resetGesture, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!gesture) return;
        var start = gesture;
        resetGesture();
        if (event.touches.length) return;
        var touch = Array.from(event.changedTouches).find(function (item) {
          return item.identifier === start.id;
        });
        if (!touch) return;
        var dx = touch.clientX - start.x;
        var dy = touch.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          select(active + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();


